<template>
  <div>
    <div class="highlight-box"
      v-for="item in items"
      :key="item[0]">
      <h3>{{item[0]}}</h3>
      <div>
        <relative-match
          v-if="item[1]"
          :relativeMatch="item[1]"
          :showBorderBottom="false">
        </relative-match>
        <div v-else>-</div>
      </div>
    </div>
  </div>

</template>
<script>
import  RelativeMatch  from '@/components/cricket/RelativeMatch'

export default {
  components : {
    'RelativeMatch': RelativeMatch
  },
  props: {
    teamKey: String,
    stats: Object
  },

  data () {
    const item = this.stats.stats
    return {
      items: [
        ["Best Won By Runs", item.best_won_by_runs],
        ["Best Won By Wickets", item.best_won_by_wickets],
        ["Highest Innings Total", item.highest_innings_total],
        ["Lowest Innings Total", item.lowest_innings_total],
        ["Lowest Innings Runs Conceded", item.lowest_innings_runs_conceded],
        ["Highest Innings Runs Conceded", item.highest_innings_runs_conceded],
      ]
    }
  },

  methods: {
  },
}
</script>
